import React from 'react'

import { OmDropdownMenu, type OmMenuItem } from '@owma/kit'
import { useTranslation } from 'react-i18next'
import styles from './EventEditor.module.scss'
import visibilityIcon from 'assets/images/calendar/property-visibility.svg'
import chevronDownIcon from 'assets/images/chevron-down-24.svg'

interface VisibilityOption {
  key: boolean
  label: string
}

interface EditEventData {
  isBusy: boolean
}

interface VisibilitySelectorProps {
  editEventData: EditEventData
  onVisibilityChange: (isBusy: boolean) => void
}

const VisibilitySelector: React.FC<VisibilitySelectorProps> = ({
  editEventData,
  onVisibilityChange,
}) => {
  const { t } = useTranslation()

  const VISIBILITY_OPTIONS: VisibilityOption[] = [
    { key: true, label: t('calendar.edit.busy') },
    { key: false, label: t('calendar.edit.free') },
  ]

  const getVisibilityItems = (): OmMenuItem[] => {
    return VISIBILITY_OPTIONS.map((option) => ({
      key: String(option.key),
      label: option.label,
      onClick: () => onVisibilityChange(option.key),
    }))
  }

  return (
    <div className={styles.visibilityWrapper}>
      <img src={visibilityIcon} alt="Visibility" className={styles.titleIcon} />
      <div className={styles.visibilityContent}>
        <div className={styles.visibilityRow}>
          <OmDropdownMenu
            menu={{ items: getVisibilityItems() }}
            trigger={['click']}
            placement="bottomLeft"
            overlayClassName={'contextMenu'}
            overlayStyle={{ width: 200 }}
          >
            <button className={styles.visibilityButton}>
              <span>
                {VISIBILITY_OPTIONS.find((option) => option.key === editEventData.isBusy)?.label}
              </span>
              <img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />
            </button>
          </OmDropdownMenu>
        </div>
      </div>
    </div>
  )
}

export default VisibilitySelector
